export default __webpack_public_path__ + "web/images/products/application_plus_white.svg";